import {RecordForm} from '../forms/RecordForm';


import {useTopLevelDomain} from '../hooks/useTopLevelDomain';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    // No id on the Add page, so there is no record to load (FNP-944).
    const {createRecord} = useTopLevelDomain();

    return (
        <FormPageLayout
            title='Add Top Level Domain'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
